import ObjectSelectorForm from 'scoreboard/components/object-selector-form'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import _ from 'lodash'
import treeContents from 'kalpa-tree/lib/contents'
import highlight from 'scoreboard/components/highlight'
import ScorecardsGardener from 'scoreboard/scorecards/scorecards-gardener'
import config from 'scoreboard/components/config'
import { Transform } from 'stream'

let MetricsOnlyGardener = ScorecardsGardener.extend({

	_treeOptions: function() {
		var treeOptions = ScorecardsGardener.prototype._treeOptions.apply(this, arguments)

		var map = new Transform({ objectMode: true })
		map._transform = function (node, enc, next) {
			// #47456 Disallow including custom text metrics in equations
			let scoringType = config.scoringType(node.scoringTypeId)
			let customText = _.get(scoringType, 'isCustomText', false)
			if (node.type != 'metric' || customText) {
				node.className = 'is-disabled'
			}
			this.push(node)
			next()
		}
		treeOptions.stream = treeOptions.stream.pipe(map)

		return treeOptions
	}

})

/**
 * For choosing a metric in an equation for the equation-form.
 */
var ReferencedObjectSelectorForm = ObjectSelectorForm.extend({

	className: 'referenced-object-selector-form ' + ObjectSelectorForm.prototype.className,

	events: _.defaults({
		'click .this-metric': 'clickThisMetric',
		'click .tree .node': 'clickTreeNode'
	}, ObjectSelectorForm.prototype.events),

	/**
	 /**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {String} options.section denotes the type of object that should be
	 * selected (either "scorecards" or "initiatives")
	 *
	 * @param {String} options.type denotes the type of reference being edited
	 * (e.g. 'metric' or 'score')
	 *
	 * @param {Boolean} [thisMetric=false] whether the "This Metric" option should be
	 * visible.  If true, the object on 'done' trigger will have `thisMetric=true`
	 */
	initialize: function(options) {
		this.FormView = FormView.extend({
			test: this.test.bind(this)
		})

		// #12376 Metric IDs on mouseover when building equations
		var theOptions = _.extend({
			contents: function(selection, tree, transitions) {
				treeContents(selection, tree, transitions)
				selection.attr('title', function(d) {
					return i18n.get('common.id') + ': ' + d.id
				})
			}
		}, options, { showProjectSelector: true })

		ObjectSelectorForm.prototype.initialize.call(this, theOptions)

		if (options.type === 'metric' || options.type === 'td') {
			this.objectSelector.ObjectGardener = MetricsOnlyGardener
		}
	},

	render: function() {
		ObjectSelectorForm.prototype.render.apply(this, arguments)
		if (this.options.thisMetric) {
			this.$('.object .finder').after(
				'<div class="this-metric"><div class="this-metric-container">' + icon('metric')
					+ '<span>' + i18n.get('scorecards.node.metric.this') + '</span>' +
				'</div></div>')
		}
		return this
	},

	clickThisMetric: function(e) {
		if (this.options.section !== 'scorecards') {
			return
		}

		this.$('.this-metric').addClass('selected')
		this.$('.tree .node').removeClass('selected')
		this.formView.change(e)
	},

	clickTreeNode: function() {
		if (this.options.section !== 'scorecards') {
			return
		}

		this.$('.this-metric').removeClass('selected')
	},

	test: function() {
		if (this.$('.this-metric').hasClass('selected')) {
			return
		}

		var selected = this.objectSelector.selected()
		if (selected) {
			let metricNeeded = this.options.section === 'scorecards' &&
				this.options.type !== 'score'
			// if a non-metric was chosen when a metric was needed
			if (metricNeeded && selected.type !== 'metric') {
				return i18n.get(
					'admin.scorecards.metric.equation.invalid.metricsOnly',
					highlight(selected.label))
			} else if (metricNeeded) {
				// #47456 disallow kpis with custom text scoring types
				let scoringType = config.scoringType(selected.scoringTypeId)
				let customText = _.get(scoringType, 'isCustomText', false)
				if (customText) {
					return i18n.get(
						'admin.scorecards.metric.equation.invalid.customTextScoringType',
						highlight(selected.label))
				} else {
					return null
				}
			} else {
				return null
			}
		} else {
			return i18n.get('common.select.required')
		}
	},

	submit: function() {
		if (this.$('.this-metric').hasClass('selected')) {
			this.trigger('select', {
				type: 'metric',
				thisMetric: true
			})
		} else {
			ObjectSelectorForm.prototype.submit.apply(this, arguments)
		}
	}

})

export default ReferencedObjectSelectorForm

ReferencedObjectSelectorForm.__filename__ = 'scorecards/edit/referenced-object-selector-form.js'
